export default __webpack_public_path__ + "images/7cf07e0f32dac5ddb65845757325b5fc.svg";